import React from "react";
import Background1 from "../../assets/images/breadcum/01.jpg";
import media from "../../assets/Upload/MediaUploadFile/f383562e04e7408ca91dfbbd4c48b2f8.jpg";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

export default function TheMillenniumLearningSystem() {
  const [dataDesc, setData] = useState("");
  const [title, setTitle] = useState("");
  const [mlsData, setMlsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/api/auth/get/getAllCMSMaster`
      );
      const data = res.data.filter(
        // (entry) => entry._id === "66254ff4dce9d44fabb8f0bf"
        (entry) => entry._id === "6956202df449f0ed619e1cef"
      );
      setData(data[0]?.Description || "");
      setTitle(data[0]?.Title || "The Millennium Learning System");
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchMLSData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/auth/AllMlsmaster`
        );
        let data = res.data;

        // Filter only active items
        data = data.filter(item => item.IsActive === true);

        // Sorting logic for Beginners and Nursery (if needed)
        const beginnersId = "66221a293b2aa1719d8421c2";
        const nurseryId = "6717672faedcb8d47a4f5e78";

        const beginnersItem = data.find(item => item._id === beginnersId);
        const nurseryItem = data.find(item => item._id === nurseryId);

        data = data.filter(item => item._id !== beginnersId && item._id !== nurseryId);

        const sortedData = [beginnersItem, nurseryItem, ...data].filter(Boolean);

        setMlsData(sortedData);
      } catch (error) {
        console.error("Error fetching MLS data:", error);
      }
    };
    fetchMLSData();
  }, []);

  return (
    <>
      {/* <!--inner-header --> */}
      <section
        className="inner-banner bg-overlay-black-70 bg-holder"
        style={{ backgroundImage: `url(${Background1})` }}
      >
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-12">
              <div className="text-center">
                <h1 className="text-white">The Millennium Learning System</h1>
              </div>
              <div className="d-flex justify-content-center ">
                <ol className="breadcrumb mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="#">Scholastics</a>
                  </li>
                  <li className="breadcrumb-item active">
                    <span>The Millennium Learning System</span>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--inner-header --> */}
      {/* <!--about --> */}
      <section className="the-millennium-learning-system-section">
        <div className="container">
          {/* <div className="row align-items-center justify-content-center">
            <div className="col-xl-10 col-lg-10">
              <div className="shadow border-radius box-border-bottom p-4">
                <div className="row">
                  <div className="col-xl-12 col-lg-12">
                    <div className="the-millennium-learning-system-content">
                      {React.createElement("div", {
                        dangerouslySetInnerHTML: {
                          __html: `${dataDesc}<style>img {width: 100%; }</style>`,
                        },
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* MLS Levels Section */}
          <div className="row align-items-center justify-content-center mt-5">
            <div className="col-xl-10 col-lg-10">
              <div className="text-center mb-4">
                <h3 style={{ color: "#0160aa", textTransform: "uppercase" }}>
                  The Millennium Learning System
                </h3>
              </div>
              {mlsData.map((item, index) =>
                index % 2 === 0 ? (
                  <div key={index} className="mt-5 mb-5 box-odd">
                    <div className="row p-4">
                      <div className="col-lg-6 d-flex align-items-center">
                        <div className="content-section">
                          <h4
                            className="text-primary2"
                            style={{ color: "#0160aa" }}
                          >
                            {item.Title}
                          </h4>
                          <p className="text-justify">{item.description}</p>
                        </div>
                      </div>
                      <div className="col-lg-6 d-flex align-items-center">
                        <div className="img-section">
                          <img
                            className="img-fluid"
                            src={`${process.env.REACT_APP_BASE_API_URL}/${item.MLSImage}`}
                            alt={item.Title}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div key={index} className="mt-5 mb-5 box-odd">
                    <div className="row p-4">
                      <div className="col-lg-6 d-flex align-items-center">
                        <div className="img-section">
                          <img
                            className="img-fluid"
                            src={`${process.env.REACT_APP_BASE_API_URL}/${item.MLSImage}`}
                            alt={item.Title}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 d-flex align-items-center">
                        <div className="content-section">
                          <h4
                            className="text-primary2"
                            style={{ color: "#0160aa" }}
                          >
                            {item.Title}
                          </h4>
                          <p className="text-justify">{item.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </section>
      {/* <!--about --> */}
    </>
  );
}
